import './index.scss';

export const SELECTORS = {
  BODY_FOR_SL_MODAL: 'js-body-for-sl-modal',
  MODAL: 'sl-modal',
  MASK: 'sl-modal-mask',
  CONTAINER: 'sl-modal-container',
  SHOW: 'sl-modal_show',
  HIDE: 'sl-modal_hide',
};

export class SlModal extends HTMLElement {
  static get observedAttributes() {
    return ['show'];
  }
  set show(value) {
    this.setAttribute('show', value);
    const show = Boolean(value);
    if (show) {
      this.setAttribute('show', '');
      this.classList.remove(SELECTORS.SHOW.HIDE);
      this.classList.add(SELECTORS.SHOW);
    } else {
      this.removeAttribute('show');
      this.classList.remove(SELECTORS.SHOW);
      this.classList.add(SELECTORS.HIDE);
    }
    this.setBodyClass();
  }
  get show() {
    return this.hasAttribute('show');
  }
  getContainer() {
    return this.querySelector(SELECTORS.CONTAINER);
  }
  constructor() {
    super();
    this.setBodyClass();
  }
  setBodyClass() {
    const openedModals = document.querySelectorAll(`${SELECTORS.MODAL}[show]`);
    if (openedModals.length > 0) {
      document.body.classList.add(SELECTORS.BODY_FOR_SL_MODAL);
    } else {
      document.body.classList.remove(SELECTORS.BODY_FOR_SL_MODAL);
    }
  }
  onShow() {
    this.show = true;
  }
  onHide() {
    this.show = false;
  }
  onMaskClick() {
    this.onHide();
  }
  connectedCallback() {
    this.bindEvents();
  }
  bindEvents() {
    this.querySelector(SELECTORS.MASK).addEventListener(
      'click',
      this.onMaskClick.bind(this),
    );
  }
}

if (!customElements.get('sl-modal')) {
  customElements.define('sl-modal', SlModal);
}

export const destroySlModal = (id) =>
  document.querySelector(`sl-modal[sl-modal-id="${id}"]`)?.remove?.();

export const createSlModal = (id, options) => {
  const $modal = document.createElement(SELECTORS.MODAL);
  $modal.setAttribute('sl-modal-id', id);
  const { content, zIndex = 99, modalClass, containerClass } = options || {};

  if (modalClass) {
    $modal.classList.add(modalClass);
  }

  $modal.innerHTML = `
    <${SELECTORS.MASK}
      style="z-index=${zIndex};">
    </${SELECTORS.MASK}>
    <${SELECTORS.CONTAINER}
      style="z-index=${zIndex};" 
      class="${containerClass || ''}">
      ${content || ''}
    </${SELECTORS.CONTAINER}>`;

  document.body.appendChild($modal);
  return $modal;
};

export const getSlModal = (id) =>
  document.querySelector(`${SELECTORS.MODAL}[sl-modal-id="${id}"]`);
